import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ReadTimeQuery } from './ReadTimeQuery.graphql';
import type {
	ReadTimeQuery as ReadTimeQueryType,
	ReadTimeQueryVariables,
} from './__types__/ReadTimeQuery';

type PreloadReadTimeParams = Pick<ReadTimeQueryVariables, 'includeContentBody' | 'status'> & {
	contentId: ReadTimeQueryVariables['contentId'];
	useCache: boolean;
};

export function preloadReadTime({
	contentId,
	includeContentBody = true,
	status,
	useCache,
}: PreloadReadTimeParams) {
	return query<ReadTimeQueryType, ReadTimeQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ReadTimeQuery,
		variables: {
			contentId,
			includeContentBody,
			status,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
